import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppTheme } from '@modules/front';
import { ModalType } from '@movecloser/front-core';
import { Inject } from '@plugin/inversify';
import { SiteLogoVariant, SiteServiceType } from '@service/site';
import { SitesNav } from '@component/SitesNav';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let Footer = class Footer extends Vue {
    get logotype() {
        const logoSize = this.site.properties.logoSize;
        return {
            src: this.site.logo[SiteLogoVariant.Light] || '',
            width: logoSize === null || logoSize === void 0 ? void 0 : logoSize.width,
            height: logoSize === null || logoSize === void 0 ? void 0 : logoSize.height
        };
    }
    showConsentPopup() {
        window.googlefc = window.googlefc || {};
        window.googlefc.showRevocationMessage();
    }
    /**
     * Whether to show the Cookies button in the footer.
     * Should NOT be shown on the KADECI RP site.
     */
    get shouldShowCookies() {
        return this.siteService.getActiveSiteTheme() === AppTheme.KadeciRPZone;
    }
    get site() {
        return this.siteService.getActiveSite();
    }
    get appver() {
        var _a;
        return (_a = process.env.VUE_APP_VERSION) !== null && _a !== void 0 ? _a : '';
    }
};
__decorate([
    Prop({ type: Array, required: false })
], Footer.prototype, "socialLinks", void 0);
__decorate([
    Prop({ type: Array, required: false })
], Footer.prototype, "sitesLinks", void 0);
__decorate([
    Prop({ type: Array, required: false })
], Footer.prototype, "bottomLinks", void 0);
__decorate([
    Prop({ type: Object, required: false })
], Footer.prototype, "mainLink", void 0);
__decorate([
    Prop({ type: Array, required: false })
], Footer.prototype, "topLinks", void 0);
__decorate([
    Inject(ModalType)
], Footer.prototype, "modalConnector", void 0);
__decorate([
    Inject(SiteServiceType)
], Footer.prototype, "siteService", void 0);
Footer = __decorate([
    Component({
        name: 'Footer',
        components: {
            SitesNav
        }
    })
], Footer);
export { Footer };
export default Footer;
